import { render, staticRenderFns } from "./SettingDetail.vue?vue&type=template&id=d684a168&scoped=true"
import script from "./SettingDetail.vue?vue&type=script&lang=js"
export * from "./SettingDetail.vue?vue&type=script&lang=js"
import style0 from "./SettingDetail.vue?vue&type=style&index=0&id=d684a168&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d684a168",
  null
  
)

export default component.exports